module.exports = __webpack_public_path__ + "img/3.cd41f3a0.jpg";